// VehicleCard.jsx
import React from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const VehicleCard = ({ vehicle }) => {
  const { lang } = useParams();
  const { t } = useTranslation();

  // Helper function to localize condition
  const getLocalizedCondition = (condition) => {
    const conditions = {
      new: t("condition_new"),
      used: t("condition_used"),
      certified: t("condition_certified")
    };
    return conditions[condition] || condition;
  };

  return (
    <div className="bg-white shadow-lg rounded-2xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl">
      <img
        src={vehicle.primaryImage}
        alt={vehicle.localizedTitle}
        className="w-full h-48 object-cover"
      />
      <div className="p-4">
        <h3 className="text-xl font-semibold text-gray-800">{vehicle.localizedTitle}</h3>
        <p className="text-gray-600 text-sm">
          {t("condition_label")}: <span className="font-medium">{getLocalizedCondition(vehicle.condition)}</span>
        </p>
        <p className="text-gray-900 font-bold text-lg">
          {vehicle.price.toLocaleString()} {t("million_cfa")} ({t("negotiable")})
        </p>

        <Link
          to={`/cm/${lang}/collections/${vehicle.categories?.[0]?.slug?.current}/${vehicle.slug?.current}`}
          className="mt-3 block bg-blue-600 text-white text-center py-2 rounded-lg hover:bg-blue-700 transition"
        >
          {t("view_details")}
        </Link>
      </div>
    </div>
  );
};

export default VehicleCard;